import { useQuery } from '@tanstack/react-query';
import {SanctionsService} from "src/services/api/sanctions";

const QUERY_KEY_SEARCH_SANCTIONS = 'QUERY_KEY_SEARCH_SANCTIONS';

export const useQuerySearchSanctions = (query: any) => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: [QUERY_KEY_SEARCH_SANCTIONS, query],
    queryFn: () => SanctionsService.search(query),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: (previousData) => previousData,
    enabled: !!query.q,
  });
  return {
    data,
    isFetching,
    refetch,
  };
};

const QUERY_KEY_GET_DETAIL_SANCTIONS = 'QUERY_KEY_GET_DETAIL_SANCTIONS';

export const useQueryGetDetailSanctions = (id: string) => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: [QUERY_KEY_GET_DETAIL_SANCTIONS, id],
    queryFn: () => SanctionsService.getDetail(id),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: {},
    placeholderData: (previousData) => previousData,
    enabled: !!id,
  });
  return {
    data,
    isFetching,
    refetch,
  };
};
